<template>
  <!-- Modal-->
  <div class="modal fade" id="appModal" ref="modal" tabindex="-1">
    <div class="modal-dialog" :class="[{'modal-dialog-centered': centered, 'overlay overlay-block': loading}, modalSize]" role="document">
      <div class="modal-content">
        <div class="modal-header p-3">
          <h5 class="modal-title" id="exampleModalLabel">{{ title }}</h5>
          <button @click="close" type="button" class="close btn btn-link" data-dismiss="modal" aria-label="Close">
            <i class="bi bi-x fs-1"></i>
          </button>
        </div>

        <div class="modal-body" v-if="message" v-html="message"></div>
        <div class="modal-body" v-else>
          <component :is="component" v-bind="componentProps" :key="componentId"></component>
        </div>

        <div class="modal-footer">

          <button
            v-if="btnCancel && !btnCancel.hide"
            type="button"
            class="btn font-weight-bold"
            data-dismiss="modal"
            :class="btnCancel.color"
            @click="cancel"
          >
            {{ btnCancel.text }}
          </button>

          <button
            v-if="btnSuccess && !btnSuccess.hide"
            type="button"
            class="btn font-weight-bold"
            :class="btnSuccess.color"
            @click="confirm"
          >
            {{ btnSuccess.text }}
          </button>
        </div>
      </div>
      <overlay :loading="loading"/>
    </div>
  </div>
</template>

<script>
import {markRaw, shallowRef} from "vue";
import Overlay from "../../../Shared/Forms/Overlay";

export default {
  components: {
    Overlay
  },
  data: _ => ({
    size: '',
    persistent: true,
    title: '',
    message: '',
    component: null,
    centered: true,
    btnSuccess: null,
    btnCancel: null,
    modal: null,
    componentProps: null,
    componentId: null,
    loading: false
  }),

  methods: {
    open(config = {}) {
      const {
        persistent = true,
        title = '',
        message = '',
        component = null,
        componentProps = null,
        centered = true,
        size = null,
        btnSuccess = {},
        btnCancel = {}
      } = config;

      if (!message && !component) throw 'required content'

      this.size = size;
      this.persistent = persistent;
      this.title = title;
      this.message = message;
      this.centered = centered;
      this.component = component;
      this.componentProps = componentProps;
      this.componentId = moment().unix()

      this.btnSuccess = {
        color: btnSuccess.color || 'btn-primary',
        click: btnSuccess.click || (_ => {}),
        closeOnClick: btnSuccess.closeOnClick ?? true,
        text: btnSuccess.text || 'Ok',
        hide: btnSuccess.hide || false,
      };

      this.btnCancel = {
        color: btnCancel.color || 'btn-light',
        click: btnCancel.click || (_ => {}),
        closeOnClick: btnCancel.closeOnClick ?? true,
        text: btnCancel.text || 'Fechar',
        hide: btnCancel.hide || false,
      };

      this.modal = new bootstrap.Modal($(this.$refs.modal), {
        backdrop: this.persistent ? 'static' : true,
        keyboard: !this.persistent
      });

      this.modal.show();
    },

    cancel() {
      this.btnCancel && this.btnCancel.click();
      this.btnCancel && this.btnCancel.click();

      if (this.btnCancel.closeOnClick) {
        this.close();
      }
    },

    confirm() {
      this.btnSuccess && this.btnSuccess.click();

      if (this.btnSuccess.closeOnClick) {
        this.close();
      }
    },

    close() {
      this.modal.hide();
    }
  },

  mounted() {
    this.emitter.on('close-modal', () => {
      this.close()
    })

    this.emitter.on('loading-modal', (data) => {
      this.loading = data
    })

    this.emitter.on('hide-modal-success', (data) => {
      this.btnSuccess.hide = true
    })

    this.emitter.on('show-modal-success', (data) => {
      this.btnSuccess.hide = false
    })
  },

  computed: {
    modalSize() {
      switch(this.size) {
        case 'small':
          return 'modal-sm';
        case 'large':
          return 'modal-lg';
        case 'extra-large':
          return 'modal-xl';
        case 'fullscreen':
          return 'modal-fullscreen';
        default:
          return 'modal-md';
      }
    },

    isSizeble() {
      return !!this.modalSize;
    }
  }

}
</script>
